import { render, staticRenderFns } from "./TwitterPostGrid.vue?vue&type=template&id=10dfe8d9"
import script from "./TwitterPostGrid.vue?vue&type=script&lang=ts"
export * from "./TwitterPostGrid.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports